import { SlingoStyle } from "@lib/titan2-slingo/dist/game/view/abstract/style/SlingoStyle";
import { SpineProperties } from "@lib/titan2/dist/game/control/properties/SpineProperties";
import { TitanSpine } from "@lib/titan2/dist/game/control/TitanSpine";
import { TitanText } from "@lib/titan2/dist/game/control/TitanText";
import { Point } from "pixi.js";
import { GameSpineUtil } from "../GameSpineUtil";
import { GameSymbolUtil } from "../GameSymbolUtil";
import { ImageTaggedText } from "./ImageTaggedText";
import { PoolUtil } from "./PoolUtil";
/**
 * Sets up the image map for summary envelope text
 */
export function getYouCouldWinText(factory, landscape, portrait) {
    const text = new ImageTaggedText(factory, new YouCouldWinTokens(), landscape, portrait);
    return text;
}
const expectedSpineSize = 45.5;
export class YouCouldWinTokens {
    constructor() {
        this.symbolFactory = new PoolUtil(() => {
            const reel = SpineTokenWrapper.createSpine(undefined, new SpineProperties("TicketSymbol", SlingoStyle.MODULE, undefined, new Point(0.25, 0.25)));
            return reel;
        });
    }
    getNextElement(token) {
        const number = Number.parseInt(token.replace("{", "").replace("}", ""));
        const symbol = this.symbolFactory.getNextElement();
        symbol.reset();
        GameSymbolUtil.setNumberSkin(symbol, number);
        GameSpineUtil.forceUpdate(symbol);
        return symbol;
    }
    releaseElement(element) {
        return this.symbolFactory.releaseElement(element);
    }
    getKeys() {
        const keys = [];
        for (let i = 1; i < 99; i++) {
            keys.push(`{${i}}`);
        }
        return keys;
    }
}
export class TextTokenWrapper extends TitanText {
    static createField(...args) {
        let _parent, _name, _properties, _portraitProperties;
        if (typeof args[1] === "string") {
            [_parent, _name, _properties, _portraitProperties] = args;
        }
        else {
            [_parent, _properties, _portraitProperties] = args;
            _name = "TextField";
        }
        let field;
        if (_properties) {
            field = new TextTokenWrapper(_properties, _portraitProperties);
            if (field && _parent) {
                _parent.addChild(field);
            }
        }
        return field;
    }
    applyPositionAndAnchor(point) {
        this.position.copyFrom(point);
    }
    getWidth() {
        this.initialiseUiText();
        return this.bounds ? this.bounds.width : this.uiText?.width ?? 0;
    }
}
export class SpineTokenWrapper extends TitanSpine {
    static createSpine(...args) {
        let hasName = typeof args[1] === "string";
        let _parent, _name, _properties, _portraitProperties, _completeHandler, __caller;
        if (hasName) {
            [_parent, _name, _properties, _portraitProperties, _completeHandler, __caller] = args;
        }
        else {
            [_parent, _properties, _portraitProperties, _completeHandler, __caller] = args;
            _name = "Spine";
        }
        let spine;
        if (_properties) {
            spine = new SpineTokenWrapper(_properties, _portraitProperties);
            if (spine) {
                if (_completeHandler && __caller) {
                    spine.onComplete(_completeHandler, __caller);
                }
                if (_parent) {
                    _parent.addChild(spine);
                }
                spine.name = _name;
            }
        }
        return spine;
    }
    //During loading, the game has often not loaded the spine in time meaning this value may be null. Therefore we set it to its expected value.
    //This is pretty ugly
    getWidth() {
        let width = super.getWidth();
        if (!width)
            width = expectedSpineSize;
        return width;
    }
    getHeight() {
        let height = super.getHeight();
        if (!height)
            height = expectedSpineSize;
        return height;
    }
    applyPositionAndAnchor(point) {
        //The tagged text will use left-center alignment. We must then manually reapply the center anchor. 
        //This is because Titan Text is a bit offset due to using size.
        const yAlignmentFix = 6;
        const width = this.getWidth();
        const height = this.getHeight();
        this.position.set(point.x + width / 2, yAlignmentFix + point.y + height / 2);
    }
}
//# sourceMappingURL=YouCouldWinFactory.js.map